import { ListLikeToneDto } from '../../dto/listliketone/listliketonedto';
import { APIResponse, APIResponseDtoImpl } from '../apiresponse';

export interface ListLikeToneResponse extends APIResponse
{
    getListLikeToneDto(): ListLikeToneDto;
}

export class ListLikeToneResponseDtoImpl extends APIResponseDtoImpl implements ListLikeToneResponse
{
    private listLikeToneDto : ListLikeToneDto;

    getListLikeToneDto(): ListLikeToneDto
    {
        return this.listLikeToneDto;
    }
    setListLikeToneDto(listLikeToneDto: ListLikeToneDto)
    {
        this.listLikeToneDto = listLikeToneDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/listlikedtone/listliketoneresponse.tsx